/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckChecklistItemRequirement } from './PaxCheckChecklistItemRequirement';
import {
    PaxCheckChecklistItemRequirementFromJSON,
    PaxCheckChecklistItemRequirementFromJSONTyped,
    PaxCheckChecklistItemRequirementToJSON,
    PaxCheckChecklistItemRequirementToJSONTyped,
} from './PaxCheckChecklistItemRequirement';

/**
 * Composed checklist item requirement: Not(ChecklistItemRequirement)
 * @export
 * @interface PaxCheckNot
 */
export interface PaxCheckNot {
    /**
     * Requirement represented as text
     * @type {string}
     * @memberof PaxCheckNot
     */
    asText: string;
    /**
     * 
     * @type {PaxCheckChecklistItemRequirement}
     * @memberof PaxCheckNot
     */
    requirement: PaxCheckChecklistItemRequirement;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckNot
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckNot interface.
 */
export function instanceOfPaxCheckNot(value: object): value is PaxCheckNot {
    if (!('asText' in value) || value['asText'] === undefined) return false;
    if (!('requirement' in value) || value['requirement'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckNotFromJSON(json: any): PaxCheckNot {
    return PaxCheckNotFromJSONTyped(json, false);
}

export function PaxCheckNotFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckNot {
    if (json == null) {
        return json;
    }
    return {
        
        'asText': json['as_text'],
        'requirement': PaxCheckChecklistItemRequirementFromJSON(json['requirement']),
        'type': json['type'],
    };
}

export function PaxCheckNotToJSON(json: any): PaxCheckNot {
    return PaxCheckNotToJSONTyped(json, false);
}

export function PaxCheckNotToJSONTyped(value?: PaxCheckNot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'as_text': value['asText'],
        'requirement': PaxCheckChecklistItemRequirementToJSON(value['requirement']),
        'type': value['type'],
    };
}

